var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{staticClass:"my_tabs",on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.list),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.label,"name":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }